"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.populate = void 0;
const utils_1 = require("./utils");
/**
 * Generates a key value lookup table with URL paths as keys and video metadata as values. Used for populating
 * meta tags in the <head> of the HTML document for SEO purposes.
 *
 * @param metaTags A partially complete lookup table of meta tags to populate
 * @param translation A BBB translation object
 */
const populate = (metaTags, translation) => {
    const translationCode = translation.translation_shortcode;
    const author = translation.team.name;
    translation.books.forEach(({ videos, book_shortcode: bookCode }) => {
        videos.forEach((video) => {
            const title = `${translationCode.toUpperCase()} | ${(0, utils_1.getReference)(video)}`;
            const description = (0, utils_1.getTitle)(video);
            const thumbnailUrl = video.thumbnail_url;
            const value = { title, author, description, thumbnailUrl };
            const iterator = (0, utils_1.chapterVerseIterator)(video);
            for (const [chapter, verse] of iterator) {
                const key = `/${translationCode}/${bookCode}.${chapter}.${verse}`.toLowerCase();
                metaTags[key] = value;
            }
        });
    });
};
exports.populate = populate;
